class PulseBrandShowcaseSlider {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.slider = this.wrapper.querySelector('[data-slider]');
    if (!this.slider) return;

    this.items = Array.from(this.slider.children);
    this.prevButton = this.wrapper.querySelector('.pbs__arrow--prev');
    this.nextButton = this.wrapper.querySelector('.pbs__arrow--next');
    this.dotsContainer = this.wrapper.querySelector('.pbs__dots');
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;

    if (this.items.length === 0) return;

    this.addEventListeners();
    this.updateArrows();
    this.updateDots();
  }

  addEventListeners() {
    this.prevButton?.addEventListener('click', () => this.prevSlide());
    this.nextButton?.addEventListener('click', () => this.nextSlide());

    this.dotsContainer?.querySelectorAll('.pbs__dot').forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        this.goToSlide(index);
      });
    });

    this.slider.addEventListener('scroll', () => {
      this.updateArrows();
      window.clearTimeout(this.scrollTimeout);
      this.scrollTimeout = window.setTimeout(() => this.updateDots(), 100);
    }, { passive: true });

    this.slider.addEventListener('mousedown', (e) => this.handleDragStart(e));
    this.slider.addEventListener('mouseleave', () => this.handleDragEnd());
    this.slider.addEventListener('mouseup', () => this.handleDragEnd());
    this.slider.addEventListener('mousemove', (e) => this.handleDragMove(e));
  }

  handleDragStart(e) {
    this.isDragging = true;
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
    this.slider.style.cursor = 'grabbing';
  }

  handleDragMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.slider.scrollLeft = this.scrollLeft - walk;
  }

  handleDragEnd() {
    this.isDragging = false;
    this.slider.style.cursor = '';
  }

  getSlideWidth() {
    const item = this.items[this.currentIndex] || this.items[0];
    if (!item) return this.slider.clientWidth;

    const style = window.getComputedStyle(this.slider);
    const gap = parseFloat(style.gap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  nextSlide() {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const targetScroll = Math.min(this.slider.scrollLeft + this.getSlideWidth(), maxScroll);
    this.slider.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  prevSlide() {
    const targetScroll = Math.max(this.slider.scrollLeft - this.getSlideWidth(), 0);
    this.slider.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  goToSlide(index) {
    const item = this.items[index];
    if (!item) return;

    this.slider.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    this.currentIndex = index;
    this.setActiveDot(index);
  }

  getCurrentIndex() {
    const scrollLeft = this.slider.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.items.forEach((item, index) => {
      const itemLeft = item.offsetLeft;
      const distance = Math.abs(itemLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  updateArrows() {
    if (!this.prevButton || !this.nextButton) return;

    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const scrollLeft = this.slider.scrollLeft;

    this.prevButton.disabled = scrollLeft <= 1;
    this.nextButton.disabled = scrollLeft >= maxScroll - 1;
    this.prevButton.style.opacity = this.prevButton.disabled ? '0.3' : '';
    this.nextButton.style.opacity = this.nextButton.disabled ? '0.3' : '';
  }

  setActiveDot(index) {
    if (!this.dotsContainer) return;

    const dots = this.dotsContainer.querySelectorAll('.pbs__dot');
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('pbs__dot--active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  updateDots() {
    this.currentIndex = this.getCurrentIndex();
    this.setActiveDot(this.currentIndex);
  }
}

function initPulseBrandShowcaseSliders() {
  document.querySelectorAll('.pbs__slider-wrapper:not([data-initialized])').forEach((wrapper) => {
    new PulseBrandShowcaseSlider(wrapper);
    wrapper.setAttribute('data-initialized', '');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPulseBrandShowcaseSliders);
} else {
  initPulseBrandShowcaseSliders();
}

document.addEventListener('shopify:section:load', initPulseBrandShowcaseSliders);

